module.exports = __webpack_public_path__ + "img/dontHave.a2be83d9.png";